import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BpcFooter from '@shared/layouts/components/footer/footer.vue';
import BpcSidebar from '@shared/layouts/components/sidebar/sidebar.vue';
import BpcHeader from '@shared/layouts/components/header/header.vue';

library.add(faCog);

@Component({
  name: 'bpc-public-calendar-layout',
  components: {
    BpcHeader,
    BpcSidebar,
    BpcFooter,
    VuePerfectScrollbar,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class PublicCalendarLayout extends Vue {
  public headercolor = null;
  public sidebarcolor = null;

  public isConfigOpen: boolean = false;

  public showTopbar = false;
  public showSidebar = false;
  public showFooter = false;
  public embed = false;
  public noPadding = false;

  public colors: string[] = [
    'bg-primary text-lighter',
    'bg-secondary text-lighter',
    'bg-success text-lighter',
    'bg-info text-lighter',
    'bg-warning text-darker',
    'bg-danger text-lighter',
    'bg-light text-darker',
    'bg-dark text-lighter',
    'bg-focus text-lighter',
    'bg-alternate text-lighter',

    'bg-vicious-stance text-lighter',
    'bg-midnight-bloom text-lighter',
    'bg-night-sky text-lighter',
    'bg-slick-carbon text-lighter',
    'bg-asteroid text-lighter',
    'bg-royal text-lighter',
    'bg-warm-flame text-darker',
    'bg-night-fade text-darker',
    'bg-sunny-morning text-darker',
    'bg-tempting-azure text-darker',
    'bg-amy-crisp text-darker',
    'bg-heavy-rain text-darker',
    'bg-mean-fruit text-darker',
    'bg-malibu-beach text-darker',
    'bg-deep-blue text-darker',
    'bg-ripe-malin text-lighter',
    'bg-arielle-smile text-lighter',
    'bg-plum-plate text-lighter',
    'bg-happy-fisher text-darker',
    'bg-happy-itmeo text-darker',
    'bg-mixed-hopes text-lighter',
    'bg-strong-bliss text-lighter',
    'bg-grow-early text-lighter',
    'bg-love-kiss text-lighter',
    'bg-premium-dark text-lighter',
    'bg-happy-green text-lighter',
  ];

  /* Lifecycle hooks */
  // created () { }
  mounted() {
    const query = this.$route.query;

    if ('showTopbar' in query && query.showTopbar === 'true') {
      this.showTopbar = true;
    }

    if ('showSidebar' in query && query.showSidebar === 'true') {
      this.showSidebar = true;
    }

    if ('showFooter' in query && query.showFooter === 'true') {
      this.showFooter = true;
    }

    if ('embed' in query && query.embed === 'true') {
      this.embed = true;
    }

    if ('noPadding' in query && query.noPadding === 'true') {
      this.noPadding = true;
    }
  }
  // updated () { }
  // destroyed () { }

  public toggleConfig(className) {
    const el = document.body;
    this.isConfigOpen = !this.isConfigOpen;

    if (this.isConfigOpen) {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }
}
